/// <reference path="../app.ts" />
class Registration {
    constructor() {
        //show or hide password
        $(".fa-eye").mousedown(function () {
            $("#passwordField").attr('type', 'text');
        }).mouseup(function () {
            $("#passwordField").attr('type', 'password');
        }).mouseout(function () {
            $("#passwordField").attr('type', 'password');
        });
        /*Display or hide validation password & eye icon*/
        this.passwordKeyUp("#passwordField", function (element) {
            if (element.val()) {
                if (element.val().length >= 8)
                    $("#validate-password").show();
                element.parent().find(".fa-eye").show();
            }
            else {
                if (element.val().length < 8)
                    $("#validate-password").hide();
                element.parent().find(".fa-eye").hide();
            }
        });
        /*check if validation password match with password*/
        this.passwordKeyUp("#passwordValidation", function (element) {
            if (element.val() === $("#passwordField").val()) {
                element.removeClass("input-validation-error");
                $("#passwordValidationText").hide();
                $("#submitRegistration").removeAttr("disabled");
            }
            else {
                element.addClass("input-validation-error");
                $("#passwordValidationText").show();
                $("#submitRegistration").attr("disabled", "disabled");
            }
        });
        app.loadingStateForDelphiBtn("#registrationForm");
    }
    /**
     * This method bind a Jquery keyup event to a input, a callback is assigned to be
     * @param elementId Input element ID
     * @param callBack a callback function
     */
    passwordKeyUp(elementId, callBack) {
        var currentInput = $(elementId);
        currentInput.on("keyup", function () {
            callBack(currentInput);
        });
    }
}
let registration = new Registration();

//# sourceMappingURL=registration.js.map
